import { DEFAULT_LOCALE, isLocale, type Locale } from "@/lib/i18n";
import type { UiMessages } from "../types";
import { de } from "./de";
import { en } from "./en";
import { es } from "./es";
import { fr } from "./fr";
import { it } from "./it";
import { ja } from "./ja";
import { nl } from "./nl";
import { pl } from "./pl";
import { pt } from "./pt";
import { ru } from "./ru";

// The interface's words in every language: small enough to ship with the page, so client components
// read them straight from here (useUi) and server ones by the page's language (ui(lang)).

const UI: Record<Locale, UiMessages> = { en, de, es, fr, it, pt, ru, ja, pl, nl };

export const ui = (lang: string | null | undefined): UiMessages => UI[isLocale(lang) ? lang : DEFAULT_LOCALE];
